<p-confirmDialog #cd>
  <ng-template pTemplate="footer">
    <button type="button" class="p-button-danger" pButton icon="pi pi-times" label="No" (click)="cd.reject()"></button>
    <button type="button" pButton icon="pi pi-check" label="Si" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>
<div class="widthDivUser flex align-items-start flex-column lg:flex-row lg:justify-content-between bg-dashboard bg-shadow p-3 border-radius-right-dashboard
            sm:flex-row col-11">
  <div class="flex w-full">
    <div class="col-4" >
      <div class="flex">
        <!-- Colonna 1: circle-progress e p-avatar -->
        <div class="col-6 lg:col-8 p-0 mt-2">
          <div class="ml-4 mb-3 lg:mb-0 border-circle p-0 position-relative">
            <!-- circle-progress -->
            <circle-progress
              [percent]="percCompleted"
              [radius]="70"
              [outerStrokeWidth]="8"
              [innerStrokeWidth]="4"
              [outerStrokeColor]="'#fccb2b'"
              [innerStrokeColor]="'transparent'"
              [animation]="true"
              [animationDuration]="300"
              [showImage]="false"
              class="circle-progress"
            ></circle-progress>

            <!-- img -->
            <p-avatar
              shape="circle"
              size="xlarge"
              class="cursor-pointer img-container"
              (click)="updateProfileImageClick()"
            >
              <img
                [src]="profileImageUrl"
                class="responsive-image"
              />
            </p-avatar>
            <img
              src="assets\img\icona-matita.png"
              alt="Modifica Foto"
              class="pencil-border mx-4 font-bold profile-pencil"
              (click)="updateProfileImageClick()"
              style="position: absolute; top: 70pt; left: 80%; transform: translate(-30%, 10%); object-fit: cover; z-index: 1; margin-top: 10%;"
            >
          </div>
        </div>
      </div>
    </div>
    <input
      type="file"
      id="profilePhoto"
      name="profilePhoto"
      #profilePhoto
      style="display: none"
      (change)="updateProfilePhoto($event.target)"
    >
    <div class="col-6 ml-6 lg:ml-3">
      <p-rating [(ngModel)]="registryCompletedPages.Rating" [cancel]="false" [readonly]="true">
        <ng-template pTemplate="onicon" *ngIf="baseImagePath == 'sapiens'">
          <i [ngClass]="{'disabled': isDisabled}">
            <img src="assets/img/Manina.png" width="28px" height="28px" />
          </i>
        </ng-template>
        <ng-template pTemplate="officon" *ngIf="baseImagePath == 'sapiens'">
          <i [ngClass]="{'disabled': true}">
            <img src="assets/img/Manina.png" width="28px" height="28px" />
          </i>
        </ng-template>
      </p-rating>
      <div class="w-full flex align-items-center flex-wrap text-sm">
        <div class="col-12 flex flex-wrap mr-5 mt-3">
          <span class="font-medium texts-900 font-bold w-full">{{registryCompletedPages.RatingTitle}}</span>
          <div class="texts mt-2 w-full">{{registryCompletedPages.RatingSubTitle}}</div><br><br>
          <div *ngIf="showBtnRedirect" class="w-full -mb-6 mt-4 flex justify-content-end p-0 btnRedirectPages">
            <button pButton pRipple label="Vai alla pagina Anagrafica" class="p-button-rounded flex justify-content-end"
                    *ngIf="!registryCompletedPages.PaginaAnagrafica" (click)="goToAnagrafica()"></button>
            <button pButton pRipple label="Vai alla pagina Lavoro" class="p-button-rounded flex justify-content-end"
                    *ngIf="!registryCompletedPages.PaginaLavoro
                                && registryCompletedPages.PaginaAnagrafica" (click)="goToLavoro()"></button>
            <button pButton pRipple label="Vai alla pagina Istruzione" class="p-button-rounded flex justify-content-end"
                    *ngIf="!registryCompletedPages.PaginaIstruzione
                              && registryCompletedPages.PaginaLavoro
                              && registryCompletedPages.PaginaAnagrafica" (click)="goToIstruzione()"></button>
            <button pButton pRipple label="Vai alla pagina Preferenze" class="p-button-rounded flex justify-content-end"
                    *ngIf="!registryCompletedPages.PaginaPreferenze
                              && registryCompletedPages.PaginaIstruzione
                              && registryCompletedPages.PaginaLavoro
                              && registryCompletedPages.PaginaAnagrafica" (click)="goToPreferenze()"></button>
          </div>

        </div>
      </div>

    </div>
  </div>
</div>
